import React, { useState } from "react";
import { Button, ListItemText, Menu, MenuItem } from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const LANGS = [
  { code: "ar", label: "العربية" },
  { code: "en", label: "English" },
];

// Language switcher. Changing the language also flips the page direction, which
// is wired to i18next's languageChanged event in index.js.
const LanguageButton = ({ compact = false }) => {
  const { i18n } = useTranslation();
  const [anchor, setAnchor] = useState(null);

  const current = LANGS.find((l) => l.code === i18n.language) || LANGS[0];

  const pick = (code) => {
    setAnchor(null);
    if (code === i18n.language) return;
    // the browser language detector was removed, so changeLanguage alone no
    // longer caches the choice — persist it before reloading or the page comes
    // back in the previous language
    try {
      localStorage.setItem("i18nextLng", code);
    } catch { /* private mode: applies for this session only */ }

    i18next.changeLanguage(code);
    // the whole shell (RTL cache, MUI theme, layout) is built from the
    // language, so a reload is the honest way to apply it everywhere at once
    window.location.reload();
  };

  return (
    <>
      <Button
        onClick={(event) => setAnchor(event.currentTarget)}
        sx={{
          minWidth: "auto",
          padding: compact ? "4px 8px" : "6px 12px",
          color: "#334155",
          border: "1px solid rgba(15,23,42,.12)",
          background: "#fff",
          fontWeight: 700,
          fontSize: "0.85rem",
          "&:hover": { background: "#F1F5F9", borderColor: "rgba(15,23,42,.2)" },
        }}
      >
        <LanguageIcon sx={{ fontSize: "1.1rem", marginInlineEnd: "6px" }} />
        {compact ? current.code.toUpperCase() : current.label}
        <KeyboardArrowDownIcon sx={{ fontSize: "1.1rem", marginInlineStart: "2px" }} />
      </Button>

      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        {LANGS.map((lang) => (
          <MenuItem
            key={lang.code}
            selected={lang.code === i18n.language}
            onClick={() => pick(lang.code)}
          >
            <ListItemText>{lang.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageButton;
